<template>
    <div class="container" :style="showNotice ? 'background: #fff' : 'background: #F3F6FA'">
        <div class="content">
            <login v-model="loginModel" @callback="gotopay"></login>
            <login v-model="loginModel2" @callback="gotoready"></login>
            <help v-model="helpModel"></help>
            <div style="display:none">
                <canvas id="canvas" width="0px" height="0px" style="dispaly: none"></canvas>
            </div>
            <div style="display: flex;align-items: center;" v-show="showNotice">
                <el-card style="width:440px;">
                    <div class="vio-tabs">
                        <span style="border-right: 1px solid #EBEDF7;" :class="{vioselect: $route.path === '/'  || $route.path === '/ticketPay'}" @click="goToPage('/')">违章查询处理</span>
                        <span :class="{vioselect: $route.path === '/pay' || $route.path === '/paying'}" @click="goToPage('/pay')">罚单代缴</span>
                    </div>
                    <img src="../assets/ticket_pay.png" alt="" style="width: 400px; height: 153px;">
                    <div style="width:100%;color:#999;font-size:14px;text-align: right; margin: 15px 0;">
                        <!--v-if="showInputHelp" 注：罚单处理周期为<span style="color:#F75A00;margin-left:5px">24小时</span>，仅现场单或已领处罚单决定书才可直接缴款。如有疑问，请参见 -->
                        <span style="cursor:pointer" @click="openHelp">常见问题</span>
                    </div>
                    <el-form style="width:100%;margin:0 auto;position: relative" label-width="100px" label-position="left">
                        <div v-if="showInputHelp" class="input-help" :style="waring?'':'background:#fff;'">            
                            <div v-if="waring||orderNumber.length==0">
                            {{
                                waring ?'该编号疑似为告知单，可能不是【处罚决定书编号】':('请填写【处罚决定书编号】，不是【违停告知单】')
                            }}
                            </div>
                            <div v-if="!waring&&orderNumber.length>0" class="black">
                            处罚决定书 <text class="blue">15-16</text> 位编号
                            </div>

                            <div v-if="orderNumber.length>0" class="input-help-num" :style="waring?'':'color:#4F7DFF;'">
                                {{noticeHelp}}
                            </div>
                            <span class="triangle-bottom" :style="waring?'':'border-top: 8px solid #fff;'">
                            </span>
                        </div>
                        <el-form-item label="处罚决定书">
                            <el-input placeholder="请输入15-16位处罚决定书编号" v-model="orderNumber" maxLength="19" @focus="bindFocus" @blur="bindBlur"></el-input>
                        </el-form-item>
                        <el-form-item label="验证码">
                            <el-input v-model="yzm" maxLength="4">
                                <template slot="append">
                                    <img :src="captchUrl" alt="" style="width: 90px;height: 30px;" @click="getCaptcha">
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <div style="text-align:center;margin-top:40px;margin-bottom:40px">
                        <el-button type="primary" style="width:200px" @click="ready">查&nbsp;&nbsp;&nbsp;&nbsp;询</el-button>
                    </div>
                </el-card>
                <div style="margin-left: 100px;width:472px;">
                    <img src="../assets/default.png" alt="" style="width:402px;height: 244px;">
                </div>
                <div style="font-size: 20px;color: #002257;text-align: center;margin-right:20px">
                    <qrcode-vue :value="downloadSrc_ios"></qrcode-vue>
                    <!-- <img src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/officeweb/code-vio.png" alt="" style="width:141px;height: 141px;"> -->
                    <p>扫码下载APP</p>
                    <p>(ios版)</p>
                </div>
                <div style="font-size: 20px;color: #002257;text-align: center;">
                    <qrcode-vue :value="downloadSrc_and"></qrcode-vue>
                    <!-- <img src="https://s4s-imges.oss-cn-hangzhou.aliyuncs.com/officeweb/code-vio.png" alt="" style="width:141px;height: 141px;"> -->
                    <p>扫码下载APP</p>
                    <p>(Andriod版)</p>
                </div>
            </div>
            <el-card v-if="showForm1">
                <div slot="header" class="clearfix">
                    <span>现场单信息</span>
                </div>
                <el-form label-width="120px" label-position="left" style="width:50%;margin:0 auto;">
                    <el-form-item label="处罚决定书">
                        {{orderNumber}}
                    </el-form-item>
                    <el-form-item label="被处罚人">
                        {{payForm.name || '-'}}
                    </el-form-item>
                    <el-form-item label="认罚日期">
                        {{payForm.renfa_time || '-'}}
                    </el-form-item>
                    <el-form-item label="罚款金额">
                        {{payForm.money || '-'}}
                    </el-form-item>
                    <el-form-item label="滞纳金">
                        {{payForm.late_free || '-'}}
                    </el-form-item>
                    <el-form-item label="违法时间">
                        {{payForm.time || '-'}}
                    </el-form-item>
                    <el-form-item label="违法城市">
                        {{payForm.city || '-'}}
                    </el-form-item>
                    <el-form-item label="违法地址">
                        {{payForm.address || '-'}}
                    </el-form-item>
                </el-form>
                <div style="text-align:center;margin-top:50px;margin-bottom:20px">
                    <el-button @click="refill">重新查询</el-button>
                    <el-button type="primary" style="margin-left:40px" @click="tryToPay">确定处理</el-button>
                </div>
            </el-card>
            <el-card v-if="showForm2" style="width:700px;margin:0 auto;">
                <div slot="header" class="clearfix">
                    <span>现场单信息填写</span>
                </div>
                <el-form label-width="120px" label-position="left" style="width:50%;margin:0 auto;">
                    <el-form-item label="处罚决定书">
                        {{orderNumber}}
                    </el-form-item>
                    <el-form-item label="被处罚人" v-if="showName">
                        <el-input type="text" v-model="nick" placeholder="请输入被处罚人姓名" />
                    </el-form-item>
                    <el-form-item label="车牌号码" v-if="!showName">
                        <sprovice v-on:changeProvice="changeProvice"/>
                    </el-form-item>
                    <el-form-item label="驾驶证号" v-if="showDrive">
                        <el-input type="text" v-model="drive_no" maxlength="19" placeholder="请输入驾驶证号" />
                    </el-form-item>
                    <el-form-item label="认罚日期">
                        <el-date-picker
                            v-model="date"
                            align="right"
                            type="date"
                            placeholder="选择日期"
                            value-format="yyyy-MM-dd"
                            style="width:100%"
                            :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="罚款金额">
                        <el-input v-model="price" placeholder="请输入罚款金额" />
                    </el-form-item>
                    <el-form-item label="滞纳金">
                        <span style="width:auto;color:#F75A00;font-weight:bold;font-size:18px" >{{ lateFree || 0 }}</span> 元
                    </el-form-item>
                    <el-form-item label="服务费">
                        <span style="width:auto;color:#F75A00;font-weight:bold;font-size:18px" >{{ ownFree || 0 }}</span> 元
                    </el-form-item>
                    <el-form-item label="上传罚单">
                        <img v-if="ticketUrl"  :src="ticketUrl" style="width:100px" />
                        <el-button size="small" v-show="ticketUrl" type="text" style="margin-left:20px" @click="chooseimg">重新上传</el-button>
                        <div v-show="!ticketUrl" @click="chooseimg">
                            <el-button type="primary" size="small">上传照片</el-button>
                            <input type="file" accept="image/*" @change="uploader" ref="file" multiple="multiple" style="display: none;">
                        </div>
                    </el-form-item>
                    <div style="text-align:center;margin-top:50px;margin-bottom:20px">
                        <el-button @click="refill">重新查询</el-button>
                        <el-button type="primary" style="margin-left:40px" @click="gotopay">确定处理</el-button>
                    </div>
                </el-form>
            </el-card>
        </div>
        
    </div>
</template>
<script>
    import sprovice from './component/Provice.vue'
    import login from './component/Login.vue'
    import help from './component/Help.vue'
    import QrcodeVue from 'qrcode.vue'
    export default {
        components: {
            'sprovice': sprovice,
            'login':login,
            'help':help,
            QrcodeVue
        },
        data() {
            return {
                showForm2: this.$store.state.handFill.showForm2,
                showForm1: this.$store.state.handFill.showForm1,
                showNotice: this.$store.state.handFill.showNotice,
                selectOrderNumber: '',
                orderNumber: this.$store.state.orderNumber || '',
                noticeHelp: this.$store.state.orderNumber || '',
                payForm: '',
                nick: this.$store.state.handFill.nick || '',
                nickCarNo: this.$store.state.handFill.nickCarNo || '',
                date: this.$store.state.handFill.date || '',
                ticketUrl: this.$store.state.handFill.ticketUrl || '',
                price: this.$store.state.handFill.price || '',
                ownFree: this.$store.state.handFill.ownFree || 0,
                lateFree: this.$store.state.handFill.lateFree || 0,
                drive_no: this.$store.state.handFill.drive_no || '',
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                },
                canTryToPay:true,
                loginModel: false,
                loginModel2: false,
                helpModel: false,
                yzm: '',
                captchKey: '',
                captchUrl: '',
                showCaptcha: true,
                needCaptcha: true,
                XcdNotice: '',
                showInputHelp: false,
                waring: false,
                downloadSrc_ios: "https://itunes.apple.com/cn/app/%E9%BD%90%E8%BD%A6%E5%A4%A7%E5%9C%A3/id1097885036?mt=8",
                downloadSrc_and: "https://a.app.qq.com/o/simple.jsp?pkgname=com.qichedasheng.s4s",
            }

        },
        mounted(){
            this.getCaptcha();
            this.getNotice();
        },
        watch: {
            price () {
                this.getVioFee()
            },
            date () {
                this.getVioFee()
            },
            orderNumber(val) {
                this.noticeHelp = this.orderNumber = val.replace(/\D/g, '').replace(/....(?!$)/g, '$& '); 
                const list = val.split('')
                if (val.length > 7&&list[6] != 1 && list[6] != 2) {
                    this.waring = true
                }else {
                    this.waring = false
                }
            }
        },
        computed:{
            showName() {
                let str = this.selectOrderNumber.slice(0,2)
                if (str === '31' || str ==='62'){
                    return false
                } else {
                    return true
                }
            },
            showDrive() {
                let str = this.selectOrderNumber.slice(0,2)
                if (str === '54' || str ==='15'){
                    return true
                } else {
                    return false
                }
            },
        },
        methods:{
            bindBlur() {
                this.showInputHelp = false
            },
            bindFocus() {
                this.showInputHelp = true
            },
            getCaptcha () {
                const that = this
                this.$request('v3/captcha', {
                    width: 180,
                    height: 80,
                    cap_len: 4,
                    dot_count: 80,
                    skew: 1
                }).then((xhr, res)=> {
                    if (res.code === 0) {
                    that.captchKey = res.data.key
                    that.captchUrl = res.data.image
                    that.yam = ''
                    }
                })
            },
            gotoready(){
                this.$emit('getLogin')
                if(this.orderNumber) {
                    this.ready()
                }
            },
            openHelp(){
                this.helpModel = true
            },
            changeProvice(carno){
                this.nickCarNo = carno
            },
            ready(){
                // if(!window.localStorage.UserTel) {
                //     this.loginModel2 = true
                //     return
                // }
                if(this.orderNumber.length>19||this.orderNumber.length<18){
                    this.$message.error("罚单格式错误,请您重新填写（15-16位）");
                    this.showNotice = true
                    this.showForm2 = false
                    this.showForm1 = false
                    return;
                }
                if (this.searchAgain) {
                    this.nick = ''
                    this.nickCarNo = ''
                    this.date = ''
                    this.price = ''
                    this.ownFree = 0
                    this.lateFree = 0
                    this.ticketUrl = ''
                    this.drive_no = ''
                }

                this.searchAgain = true
                let self = this;
                let param = {
                    access_token:"3b2P0oarLbtrU/IkydUON5pfdQhGW4fWzFgFqOZZDi8=",
                    document:this.orderNumber.replace(/\s/g,"")
                }
                if (this.needCaptcha) {
                    param.cap_value = this.yzm;
                    param.cap_key = this.captchKey;
                }
                this.$request('v3/violation/web/ticket_query',param).then((xhr, res) => {
                    if (res.code === 90027) {
                        this.$message.error(res.msg ||"需要填写验证码");
                        this.getCaptcha();
                        this.isCaptchaTrue = false;
                        this.showCaptcha = true;
                        this.needCaptcha = true;
                        return;
                    }
                    if(res.code == 20022) {
                        self.loginModel2 = true
                        return;
                    }
                    if (res.code >= 40000 && res.code < 50000) {
                        self.loginModel2 = true
                        return;
                    }
                    if (res.code == 0) {
                        this.selectOrderNumber = this.orderNumber
                        this.$store.state.orderNumber = this.selectOrderNumber
                        if(res.data.code!=1000){
                            this.showNotice = false;
                            this.payForm = res.data.Violation
                            this.showForm2 = true
                            this.showForm1 = false
                        } else if(res.data.code==1000){
                            if(res.data.Violation==null || !res.data.Violation){
                                this.$message.warning('您的罚单已缴费，无需处理');
                            } else if(res.data.Violation.renfa_time == ''){
                                this.$message.warning('您的罚单尚未认罚，请认罚后处理');
                            } else {
                                this.showNotice = false;
                                this.payForm = res.data.Violation
                                this.payForm.late_free = (res.data.late_free / 100).toFixed(2)
                                this.payForm.own_free = (res.data.own_free / 100).toFixed(2)
                                this.showForm1 = true
                                this.showForm2 = false

                            }
                        }
                    // }else if(res.code == 90011){
                    }else{
                        this.selectOrderNumber = this.orderNumber
                        this.$store.state.orderNumber = this.selectOrderNumber
                        this.showNotice = false;
                        if(res.data && res.data.Violation) {
                            this.payForm = res.data.Violation
                        }
                        this.showForm2 = true
                        this.showForm1 = false
                    }
                    // else{
                    //     this.showNotice = true
                    //     this.showForm2 = false
                    //     this.showForm1 = false
                    //     this.$message.error(res.msg);
                    // }
                }).catch(e=>{
                    this.selectOrderNumber = this.orderNumber
                    this.$store.state.orderNumber = this.selectOrderNumber
                    this.showNotice = false
                    this.showForm2 = true
                    this.showForm1 = false
                    this.$message.error(e);
                    // 测试
                });
            },
            getVioFee() {
                let self = this;
                this.canTryToPay = false
                if(!this.price) {
                    return
                }
                if(!this.date) {
                    return
                }
                let param = {
                    notice_num: this.orderNumber.replace(/\s/g,""),
                    fine: Number(this.price) * 100,
                    vio_time: this.date
                }
                this.$request('v3/violation/fee', param).then((xhr, res) => {
                    if (res.code == 0) {
                        self.ownFree = Number( res.data.OwnFree ? (res.data.OwnFree /100).toFixed(2) : 0);
                        self.lateFree = Number(res.data.LateFree ? (res.data.LateFree /100).toFixed(2) : 0);
                        self.canTryToPay = true
                    } else {
                        self.$message.error(res.msg ? res.msg : '服务繁忙,请稍后再试');
                        self.canTryToPay = false
                        self.ownFree = 0;
                        self.lateFree = 0;
                    }
                });
            },
            uploader() {
                let list = this.$refs.file.files;
                if (list.length != 1) {
                    self.$message.error('最多只能选择1张处罚单。');
                    return
                }
                let item = {
                    name:list[0].name,
                    size:list[0].size,
                    file:list[0]
                }
                this.html5Reader(list[0],item,'ticket')
            },
            chooseimg() {
                this.$refs.file.click();
            },
            html5Reader: function(file, item, name) {
                let imgSrc = new Image();
                let reader = new FileReader();
                reader.onload = (e) => {
                    imgSrc.src = e.srcElement.result;
                    this.$set(item, 'src', e.srcElement.result);
                    let self = this;
                    imgSrc.onload = function() {
                        // 图片原始尺寸
                        var originWidth = this.width;
                        var originHeight = this.height;
                        // 最大尺寸限制
                        var maxWidth = 600, maxHeight = 600;
                        // 目标尺寸
                        var targetWidth = originWidth, targetHeight = originHeight;
                        // 图片尺寸超过400x400的限制
                        if (originWidth > maxWidth || originHeight > maxHeight) {
                            if (originWidth / originHeight > maxWidth / maxHeight) {
                                // 更宽，按照宽度限定尺寸
                                targetWidth = maxWidth;
                                targetHeight = Math.round(maxWidth * (originHeight / originWidth));
                            } else {
                                targetHeight = maxHeight;
                                targetWidth = Math.round(maxHeight * (originWidth / originHeight));
                            }
                        }
                        let canvas = document.getElementById('canvas');
                        let context = canvas.getContext('2d');
                        // canvas对图片进行缩放
                        canvas.width = targetWidth;
                        canvas.height = targetHeight;
                        // 清除画布
                        context.clearRect(0, 0, targetWidth, targetHeight);
                        // 图片压缩
                        context.drawImage(imgSrc, 0, 0, targetWidth, targetHeight);
                        // canvas转为blob并上传
                        canvas.toBlob(function (blob) {
                        //    var b = {
                        //         file: blob,
                        //         name: item.name,
                        //         size: blob.size,
                        //         src: imgSrc.src
                        //     }
                            const formData = new FormData();
                            formData.append("image", blob, item.name);
                            // const formData = new FormData();
                            // formData.append("image", file);

                            self.$message.info("正在上传");
                            const xhr = new XMLHttpRequest();
                            xhr.upload.addEventListener('progress', self.uploadProgress, false);
                            xhr.open('POST', 'https://mys4s.cn/car/upload_report_pic', true);
                            xhr.send(formData);
                            xhr.onload = () => {
                                if (xhr.status === 200 || xhr.status === 304) {
                                    let data = JSON.parse(xhr.response)
                                    if(data.code == 0) {
                                        self.$message.success("上传成功");
                                        if(name === 'ticket') {
                                            self.ticketUrl = data.data
                                        }
                                    } else {
                                        self.$message.error(data.msg);
                                    }
                                } else {
                                    self.$message.error('图片上传失败,请重新上传');
                                }
                            }
                        },file.type ||  'image/png');
                    }
                }
                reader.readAsDataURL(file);
            },
            gotopay(){
                if(!window.localStorage.UserTel){
                    this.loginModel = true
                    this.$message.error('请您先登录')
                    return
                } else {
                    this.$emit('getLogin')
                }
                this.tryToPay()
            },
            goToPage(path) {
                this.$store.state.orderNumber = ''
                this.$store.state.handFill = {
                    nick: '',
                    nickCarNo:'',
                    date:'',
                    ticketUrl: '',
                    price: '',
                    ownFree: 0,
                    lateFree:  0,
                    showForm1: false,
                    showForm2: false,
                    showNotice: true,
                    drive_no: false,
                }
                this.$router.push({
                    path: path,
                })
            },
            getNotice() {
                this.$request('v3/violation/view/notice').then((xhr, res) => {
                    if (res.code === 0 && res.data) {
                        if (res.data.XcdHave) {
                            this.XcdNotice = res.data.XcdNotice;
                        }
                    } else {
                        this.XcdNotice = null;
                    }
                }).catch(() => {
                    this.XcdNotice = null;
                });
            },
            tryToPay(){
                
                if (this.showForm2) {
                    
                    // let tel= /^1\d{10}$/
                    let money = /^-?\d+\.?\d{0,2}$/
                    let drivenoReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
                    let car = /(^[\u4E00-\u9FA5]{1}[A-Z0-9]{6}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{7}$)|(^[A-Z]{2}[A-Z0-9]{2}[A-Z0-9\u4E00-\u9FA5]{1}[A-Z0-9]{4}$)|(^[\u4E00-\u9FA5]{1}[A-Z0-9]{5}[挂学警军港澳]{1}$)|(^[A-Z]{2}[0-9]{5}$)|(^(08|38){1}[A-Z0-9]{4}[A-Z0-9挂学警军港澳]{1}$)/
                    if(!this.nick && this.showName) {
                        this.$message.error("请输入当事人姓名");
                        return
                    }
                    if(this.nickCarNo) {
                        this.nickCarNo = this.nickCarNo.toUpperCase()
                    }
                    if (!this.showName) {
                        if(!this.nickCarNo) {
                            this.$message.error("请您输入车牌号码");
                            return
                        } else if(!car.test(this.nickCarNo)){
                            this.$message.error("您输入的车牌号码有误");
                            return
                        }
                    }
                    if(this.showDrive) {
                        if(!this.drive_no) {
                            this.$message.error('请您输入驾驶证号');
                            return;
                        }else if (!drivenoReg.test(this.drive_no)) {
                            this.$message.error('请您输入正确的驾驶证号');
                            return;
                        }
                    }
                    if(!this.date){
                        this.$message.error("请您选择认罚日期");
                        return
                    } else{
                        var selectDate = new Date(this.date.slice(0,10) + 'T00:00:00'), nowDate = new Date();
                        var d = selectDate.getTime() - nowDate.getTime();
                        if(d>0){
                            this.$message.error("认罚日期不得大于今天");
                            return
                        }
                    }
                    if(!this.price) {
                        this.$message.error("请您输入罚款金额");
                        return
                    } else if (!money.test(this.price)) {
                        this.$message.error("您输入的罚款金额有误");
                        return
                    } else if(this.price < 40){
                        this.$message.error("您输入的罚款金额有误");
                        return
                    }
                    if(!this.canTryToPay) {
                        this.$message.error('请您重新输入金额或时间,需计算滞纳金及手续费');
                        return
                    }
                    if(!this.ticketUrl) {
                        this.$message.error("请您上传处罚单");
                        return
                    }
                    // this.payForm = {
                    //     money: this.price,
                    //     renfa_time: this.date,
                    //     late_free: this.lateFree,
                    //     own_free: this.ownFree,
                    //     name: this.nick,
                    //     tel: this.phone,
                    //     car_no: this.nickCarNo,
                    // }
                    this.$store.state.handFill = {
                        nick: this.nick || '',
                        nickCarNo: this.nickCarNo || '',
                        date: this.date || '',
                        ticketUrl: this.ticketUrl || '',
                        price: this.price || '',
                        ownFree: this.ownFree ||0,
                        lateFree: this.lateFree || 0,
                        showForm1: this.showForm1,
                        showForm2: this.showForm2,
                        showNotice: this.showNotice,
                        drive_no: this.drive_no || '',
                    }
                }
                if(this.showForm1) {
                    this.$store.state.handFill = {
                        nick: this.payForm.name || '',
                        nickCarNo: this.payForm.car_no || '',
                        date: this.payForm.renfa_time || '',
                        ticketUrl: this.ticketUrl || '',
                        price: this.payForm.money || '',
                        ownFree: this.payForm.own_free ||0,
                        lateFree: this.payForm.late_free || 0,
                        showForm1: this.showForm1,
                        showForm2: this.showForm2,
                        showNotice: this.showNotice,
                        drive_no: this.payForm.drive_no || '',
                    }
                }
                
                if(this.canTryToPay) {
                    if (this.XcdNotice) {
                        this.$alert(this.XcdNotice.Content, this.XcdNotice.Title, {
                            confirmButtonText: '我知道了',
                            callback: () => {
                                this.$router.push({
                                    path: '/paying'
                                })
                            }
                        });
                    } else {
                        this.$router.push({
                            path: '/paying'
                        })
                    }
                }
                // this.showNotice = false;
                // this.showForm1 = false;
                // this.showForm2 = false;
            },
            refill(){
                this.showNotice = true
                this.showForm2 = false
                this.showForm1 = false
                this.orderNumber = ''
                this.$store.state.orderNumber = ''
                this.$store.state.handFill = {
                    nick: '',
                    nickCarNo:'',
                    date:'',
                    ticketUrl: '',
                    price: '',
                    ownFree: 0,
                    lateFree:  0,
                    showForm1: false,
                    showForm2: false,
                    showNotice: true,
                    drive_no: false,
                }
            }
        }
    }
</script>
<style scoped>
.vio-tabs{
    width: 100%;
    height: 50px;
    margin: 5px 0 25px;
    border: 1px solid #EBEDF7;
    display: flex;
}
.vio-tabs span{
    flex: 1;
    text-align: center;
    line-height: 50px;
    color: #002257;
    font-size: 16px;
}
.vio-tabs .vioselect{
    color: #3A82FF;
    border-bottom: 2px solid #3A82FF;
}


/* input 版本 */
.input-help {
  position: absolute;
  width: 400px;
  z-index: 999;
  border: 1px #eaeaea solid;
  box-shadow: 0 5px 6px 0 #EFEFEF;
  transform: translate3d(0,-120%,0);
  display:flex;
  align-items: center;
  justify-content: center;
  background-color: #F8E5CD;
  color: #E89102;
  font-size: 13px;
  text-align: center;
  min-height: 60px;
  box-sizing: border-box;
  border-radius: 2px;
  flex-direction: column;
  padding: 5px 0;
}
.input-help-num {
  font-size: 26px;
  color: #E89102;
}
.triangle-bottom {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate3d(-50%,100%,0);
  z-index: 999;
  width: 0;
  height: 0;
  vertical-align: middle;
  border-bottom: 8px solid rgba(0, 0, 0, 0);
  border-right: 8px solid rgba(0, 0, 0, 0);
  border-top: 8px solid #F8E5CD;
  border-left: 8px solid rgba(0, 0, 0, 0);
  display: inline-block;
}
.black {
  color: #24252d;
}
.blue {
  color: #3A82FF;
}
</style>

